export const JOI_HEBREW = {
    'string.alphanum': 'חייב להכיל רק תווים אלפא-נומריים',
    'string.base': 'חייבת להיות מחרוזת',
    'string.base64': 'חייבת להיות מחרוזת base64 חוקית',
    'string.creditCard': 'חייב להיות כרטיס אשראי',
    'string.dataUri': 'חייבת להיות מחרוזת dataUri חוקית',
    'string.domain': 'חייב להכיל שם דומיין חוקי',
    'any.required': 'שדה חובה',
    'string.email': 'חייב להיות דוא"ל חוקי',
    'string.empty': 'יש למלא את השדה',
    'string.guid': 'חייב להיות GUID חוקי',
    'string.hex': 'חייב להכיל רק תווים הקסדצימליים',
    'string.hexAlign': 'ייצוג hex חייב להיות מיושר בתים',
    'string.hostname': 'חייב להיות שם מארח חוקי',
    'string.ip': 'חייבת להיות כתובת IP חוקית עם CIDR {{#cidr}}',
    'string.ipVersion': 'חייבת להיות כתובת IP חוקית של אחת מהגרסאות הבאות {{#version}} עם CIDR {{#cidr}}',
    'string.isoDate': 'חייב להיות בפורמט ISO',
    'string.isoDuration': 'חייב להיות משך ISO 8601 חוקי',
    'string.length': 'האורך חייב להיות באורך {{#limit}} תווים',
    'string.lowercase': 'חייב להכיל רק תווים קטנים',
    'string.max': 'האורך חייב להיות קטן או שווה ל-{{#limit}} תווים',
    'string.min': 'האורך חייב להיות לפחות {{#limit}} תווים',
    'string.normalize': 'חייב להיות מנורמל ב-unicode בצורת {{#form}}',
    'string.token': 'חייב להכיל רק תווים אלפא-נומריים ותווים קו תחתון',
    // 'string.pattern.base': 'עם הערך {:[.]} לא מצליח להתאים לדפוס הנדרש: {{#regex}}',
    'string.pattern.name': 'עם הערך {:[.]} לא מצליח להתאים לתבנית {{#name}}',
    'string.pattern.invert.base': 'עם הערך {:[.]} תואם לתבנית ההפוכה: {{#regex}}',
    'string.pattern.invert.name': 'עם הערך {:[.]} תואם לתבנית {{#name}} הפוכה',
    'string.trim': 'אין לרווח לבן מוביל או נגרר',
    'string.uri': 'חייב להיות Uri חוקי',
    'string.uriCustomScheme': 'חייב להיות URI חוקי עם סכימה התואמת לתבנית {{#scheme}}',
    'string.uriRelativeOnly': 'חייב להיות Uri יחסי חוקי',
    'string.uppercase': 'חייב להכיל רק תווים רישיות',
};